<template>
  <button @click.stop="$emit('click')"></button>
</template>

<script>
export default {

}
</script>

<style lang="scss" scoped>
button {
  background-color: var(--color-pri);
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 16px;
  &::before {
    content: '';
    display: inline-block;
    width: 16px;
    height: 16px;
    background-color: #FFFFFF;
    -webkit-mask-image: url(./svg/btn/edit.svg);
    mask-image: url(./svg/btn/edit.svg);
    -webkit-mask-repeat: no-repeat;
    mask-repeat: no-repeat;
    -webkit-mask-position: center;
    mask-position: center;
    -webkit-mask-size: contain;
    mask-size: contain;
  }
}
</style>
